import { Component, OnInit } from '@angular/core';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NewContentLocker } from 'src/app/models/pubModel/contentlocker.model';
import { ActivatedRoute, Router } from '@angular/router';
import { LockerService } from '../../../../shared/services/pubServices/lockers.service';
import { Options, LabelType } from 'ngx-slider-v2';

@Component({
  selector: 'pub-gatewayedit-component',
  templateUrl: './content-edit.html',
  styleUrls: ['./content-edit.scss']
})

export class contentEditComponent implements OnInit {
  templateEditorStep: string = 'offers'
  contentLocker = new NewContentLocker();
  noOffers: any;
  oldh2Text: any;
  errorMessage = '';
  range = (start, end) => Array.from({length: (end - start)}, (v, k) => k + start);
  sliderLeadsValue: number = 1;
  sliderValue: number;
  active = 'general';

  constructor(private toastrService: ToastrService,
              private router: Router,
              private route: ActivatedRoute,
              private lockerService: LockerService) {
  }

  ngOnInit() {
    this.getContentLocker(this.route.snapshot.params?.['id']);
  }

  // Custom class slider
  custSlideroptions: Options = {
    floor: 10,
    ceil: 100,
    step: 10,
    showTicks: true,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>leads of all offers:</b> ' + value +'%';
        default:
          return value + '%';
      }
    }
  };

  getContentLocker(id: any): void {
    // id - jest numerem content lockera dla danego Publishera
    // poprzez API ściągnąć zawartość i wpisać do poniższej struktury
      this.lockerService.getContentLocker(id)
        .subscribe(
          data => {
            this.contentLocker = data.data;
            console.log("LOCKER: ", this.contentLocker);
            this.noOffers = this.range(1, this.contentLocker.offersNumbers! + 1);
            this.oldh2Text = this.contentLocker.h2Text;
            this.onChangeLeads();
          },
          error => {
            console.log(error);
          });
  }

  offerChange(){
    this.noOffers = this.range(1, this.contentLocker.offersNumbers! + 1);
  }

  getOfferBackground(i) {
    if (i % 2 === 0) {
      return this.hexToRgbAOffer(this.contentLocker.offerEvenBackgroundColor) //this.editForm.value.offerNthBackground
    } else {
      return ''
    }
  }

  hexToRgbAOffer(hex){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+ this.contentLocker.offerEvenBackgroundColorOpacity +')';
    }
    throw new Error('Bad Hex');
    }

  hexToRgbA(hex){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+ this.contentLocker.overlayOpacity +')';
    }
    throw new Error('Bad Hex');
    }

    public tabChange(changeEvent: NgbNavChangeEvent) {
      switch (changeEvent.nextId)
        {
          case "General":
            this.templateEditorStep='offers';
            break;

          case "Overlay":
            this.templateEditorStep='offers';
            break;

          case "Mainframe":
            this.templateEditorStep='offers';
            break;

          case "Header":
            this.templateEditorStep='offers';
            break;

          case "Subheader":
            this.templateEditorStep='offers';
            break;

          case "Offers":
            this.templateEditorStep='offers';
            break;

          case "Notice":
            this.templateEditorStep='offers';
            break;

          case "Waiting":
            this.templateEditorStep='waiting';
            break;
        }
    }

  onSave(){
    this.contentLocker.contentLockerUnlockType = Number( this.contentLocker.contentLockerUnlockType);

    this.lockerService.updateContentLocker(this.route.snapshot.params?.['id'], this.contentLocker).subscribe(
      response => {
        // zwraca aplikacja API
        if(response.error)
        {
          this.errorMessage = response.error.errors[0].message;
          this.toastrService.error(`${this.errorMessage}`, 'Error !');
        }
        else
        {
          this.toastrService.success('Content locker edited', 'Success !');
          this.router.navigate(['/pub/gateways']);
        }
      },
      err => {
        // zwraca serwer HTML
        this.errorMessage =  err.status + ` - ` + err.statusText;
        this.toastrService.error(`${this.errorMessage}`, 'Error !');
      });

  }

  onCancel(){
    this.router.navigate(['/pub/gateways']);
  }

  onChangeLeads(){
    if(this.contentLocker.isLockerLeadsOn == true)//1-yes 2-no
    {
      this.sliderLeadsValue = Math.floor((this.contentLocker.lockerLeadsInPercent! * this.contentLocker.offersNumbers!)/100);
      if(this.sliderLeadsValue < 1)
        this.sliderLeadsValue = 1;

      this.contentLocker.h2Text="Please complete " + this.sliderLeadsValue + " of offer below to unlock:";
    }
  }

  onChangeVisible(){
    if(this.contentLocker.isLockerLeadsOn == true)
      this.contentLocker.h2Text = "Please complete " +  this.sliderLeadsValue + " of offer below to unlock:";
    if(this.contentLocker.isLockerLeadsOn == false)
      this.contentLocker.h2Text = "Please complete one of offer below to unlock";
  }

  onChangeh2Text(){
    this.oldh2Text = this.contentLocker.h2Text;
  }
}
